<template functional>
    <h2 class="section-header" :class="data.staticClass">
        <slot></slot>
    </h2>
</template>

<script>
export default {
    name: 'SectionHeader'
};
</script>

<style lang="scss" scoped>
@use '@/styles/variables';
@use '@/styles/bootstrap/breakpoints' as breakpoints;

.section-header,
::v-deep() {
    font-size: 20px;
    padding: 0;
    margin-bottom: variables.$grid-padding;
    font-weight: bold;

    @include breakpoints.media-breakpoint-down(variables.$mobile-breakpoint-max) {
        text-transform: uppercase;
        font-size: 16px;
        font-weight: bold !important;
    }
}
</style>
